import { create } from "zustand";
import { mirroredStore } from "@/lib/mirrored-store";

type State = {
  completedExecutionIds: string[];
  markCompleted: (executionId: string) => void;
};

/** Delivery evidence outlives the visual cursor and its target window. */
export const usePresentationCompletionStore = create<State>()(
  mirroredStore("presentationCompletion", (set) => ({
    completedExecutionIds: [],
    markCompleted: (executionId) =>
      set((state) => ({
        completedExecutionIds: [
          ...state.completedExecutionIds.filter((id) => id !== executionId),
          executionId,
        ].slice(-32),
      })),
  })),
);
